import { USER_TYPE_LIST } from "../../lib/const";
import React from "react";

export const UserProfileInline = ({ id = null, name = null, type = null,
    school = null, image = null, createdAt = null, className = "", children=null}) => {

    let imageUrl = image || `${process.env.PUBLIC_URL}/static/images/user/basic_badge.png`;
    if (id === null) imageUrl = `${process.env.PUBLIC_URL}/static/images/user/deleted_account_badge.png`;

    return (
        <div className={`user-profile-inline ${className} fs-14`}>
            <img className="icon image p-r-1" src={imageUrl} alt="사용자 프로필 이미지" />

            <div>
                <div className="info">
                    <strong className="fs-16">{name || '이용자'}</strong>
                    {id === null && <span className="deleted_account">(탈퇴)</span>}
                    {type && type!=='student' && (
                        <span className={`user-type ${type}`}>{USER_TYPE_LIST[type]}</span>
                    )}
                    {children}
                </div>
                <div className="school fc-light-gray">
                    {school !== null && <p><i className="fa-solid fa-graduation-cap"></i> {school}</p>}
                    {createdAt && <span className="fc-gray fs-12">({createdAt} 작성)</span>}
                </div>
            </div>
        </div>
    );
};
